import React from 'react';

import t from '../../../labels/labelling-utils';
import { makeClassNames } from '../../../utils/styles';
import './match-table-head.scss';

/**
 * Results Table HEAD for SEO metadata
 * it's always hidden by default
 */

const getLabels = () => {
  return {
    MATCH_LINK: t('match.table.head.match.link'),
    MATCH_RESULT: t('match.table.head.match.result'),
    TEAM_ONE: t('match.table.head.team.one'),
    TEAM_TWO: t('match.table.head.team.two'),
    MATCH_STATUS: t('match.table.head.match.status'),
    MATCH_GROUP: t('match.table.head.match.group'),
  };
};

export interface IMatchTableHead {
  hasRoundGroup?: boolean;
}

const classNames = () =>
  makeClassNames({
    matchTableHead: 'match-table-head',
  });

const MatchTableHead = ({ hasRoundGroup }: IMatchTableHead) => {
  const cn = classNames();
  const labels = getLabels();

  return (
    <thead className={cn.matchTableHead}>
      <tr>
        <th>{labels.MATCH_LINK}</th>
        <th />
        {hasRoundGroup && <th>{labels.MATCH_GROUP}</th>}
        <th>{labels.TEAM_ONE}</th>
        <th>{labels.MATCH_RESULT}</th>
        <th>{labels.TEAM_TWO}</th>
        <th>{labels.MATCH_STATUS}</th>
        <th />
      </tr>
    </thead>
  );
};

export default MatchTableHead;
